import React from 'react';
import { ActionButton, Title, LoadingShimmer } from '@icarros/ids-react';
import { useHistory } from 'react-router-dom';
import { ResumeHeader } from './style';
import { useProposalsContext } from '../../../store/contexts/proposals';

export function Header(): JSX.Element {
  const history = useHistory();
  const { currentAd, loading, proposals } = useProposalsContext();
  const { marcaNome, versaoNome } = currentAd || {};

  return (
    <ResumeHeader>
      <ActionButton
        variant="neutral"
        weight="small"
        text="voltar"
        iconName="itaufonts_seta"
        onClick={() => history.goBack()}
      />

      <LoadingShimmer show={loading} height="35px" width="350px">
        {proposals && proposals.length > 0 ? (
          <Title>
            mensagens recebidas para {marcaNome} {versaoNome}
          </Title>
        ) : (
          <></>
        )}
      </LoadingShimmer>
    </ResumeHeader>
  );
}
